import { request } from "@/utils/request";
// 查询
export function selectApi(data) {
  return request({
    url: `/public/wechatNotify/sendVisitor/select`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}

// 新增
export function addApi(data) {
  return request({
    url: `/public/wechatNotify/sendVisitor/add`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}

/* 修改 */
export function updateApi(data) {
  return request({
    url: `/public/wechatNotify/sendVisitor/update`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}

// 删除
export function deleteApi(data) {
  return request({
    url: `/public/wechatNotify/sendVisitor/delete`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}
